'use strict';



export function vpageCtrl($scope, $rootScope, AuthenticationService,ResourcesDataService,uiGridConstants,MessagingService,$timeout,$stateParams,GridsterService,$element,dragularService,MenuService) {
    
    $scope.gridsterType ="page";
    $scope.CTRLNAME='vpageCtrl';

      var page_id=$stateParams.pageid;
      var lang=$rootScope.globals.currentUser.lang;
      $scope.resourceId=page_id;//MenuService.getResourceDefIdByPageId(page_id,lang).id;
      
      $scope.dashboard={widgets : GridsterService.getEmptyTaskForm()};
       $scope.formDefinition=true;
       $scope.formRenderingCompleted=false;
       
        $scope.getResourceForm = function () {
             
              ResourcesDataService.getResourceForm($scope.resourceId,'i',lang).then(function(data) {
                                if (data.data.widgets.length>0)
                                {
                                     $scope.dashboard.widgets=data.data.widgets;
                                }           
                                $scope.resourceDefinition= data.data.resourceDefinition;
                                $scope.pageLoaded=true;                    
                                //**********************************************************
                                //          Drag And Drop dragular
                                //**********************************************************
                  
                                },function(error){
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.pageLoaded=true;    
                             });
      };
  
      if ($scope.resourceId != undefined)
      {
        $scope.getResourceForm();
        
      }else{
        
         $scope.formLoaded=true;
         $scope.unauthorised = true;
         
      }
      
      $scope.pageGridItems = [];
      
      $scope.calcRowSize = function()
      {
        $scope.rowSizes="";
        for (let i=0;i<$scope.NoOfRows;i++)
        {
         $scope.rowSizes = $scope.rowSizes+" auto";
        }
        
       $scope.BuildGrid();
      }
      $scope.calcColumnSize = function()
      {
        $scope.columnSizes="";
        for (let i=0;i<$scope.NoOfColumns;i++)
        {
         $scope.columnSizes = $scope.columnSizes+" auto";
        }
            
        $scope.BuildGrid();
      }
       $scope.BuildGrid = function()
       {
            $scope.pageGridItems.length=0;
            let itemLength = $scope.NoOfRows*$scope.NoOfColumns;
             
             for (let j=0;j<itemLength;j++)
             {
                $scope.pageGridItems.push({id:j+1});
             }
      }
      /*
      $scope.$on('LastRepeaterElement',function(event, data){
        
         $timeout(function(){
              
                  $scope.formLoaded=true;
                      
                      },1000); 
      
      
      });
      
       $scope.$on('PageLoaded',function(event, data){
        
         $timeout(function(){
              
                  $scope.pageLoaded=true;
                      
                      },100); 
      
      
      });
      */
    }
